import React from 'react';
import PropTypes from 'prop-types';
import {graphqlError} from 'components/GraphQLError';
import {LoadingScreen} from 'components/LoadingScreen';
import NotAuthorized from './components/NotAuthorized';
import {RequireScope} from './RequireScope';
import {withRouter} from 'react-router-dom';
import {logout} from './actions';
import {connect} from 'react-redux';

export class RequireAuthenticationWithoutRouter extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        onError: PropTypes.func,
        scope: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
        permissions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
        requireSuperUser: PropTypes.bool,
        history: PropTypes.shape({
            push: PropTypes.func
        }),
        location: PropTypes.shape({
            pathname: PropTypes.string
        }),
        logout: PropTypes.func,
        logoutAndRedirectIfNotLoggedIn: PropTypes.bool
    };

    static defaultProps = {
        onError: graphqlError,
        logoutAndRedirectIfNotLoggedIn: true
    };

    renderLoading = () => (
        <LoadingScreen>
            <p><i>Authenticating...</i></p>
        </LoadingScreen>
    );

    renderFallback = () => {
        if (this.props.logoutAndRedirectIfNotLoggedIn) {
            return <NotAuthorized redirectPath={`/logout?redirect=${this.props.location.pathname}`}/>;
        }

        return null;
    };

    render() {
        return (
            <RequireScope
                loading={this.renderLoading} fallback={this.renderFallback} scope={this.props.scope}
                permissions={this.props.permissions} requireSuperUser={this.props.requireSuperUser}
                onError={this.props.onError}>
                {() => this.props.children()}
            </RequireScope>
        );
    }
}

function mapStateToProps() {
    return {};
}

const mapDispatchToProps = {logout};

export const RequireAuthentication = withRouter(connect(mapStateToProps, mapDispatchToProps)(RequireAuthenticationWithoutRouter));

export function requireAuthentication(WrappedComponent, options = {}) {
    const RequireAuthenticationHoc = (props) => (
        <RequireAuthentication scope={options.scope} permission={options.permissions} requireSuperUser={options.requireSuperUser}>
            {() => <WrappedComponent {...props}/>}
        </RequireAuthentication>
    );
    return RequireAuthenticationHoc;
}
